import MachineLearningResult from './MachineLearning/MachineLearningResult';

/**
 * Slim waveform summary returned by the passage list endpoint.
 * Contains only what the history table needs to render buttons/icons per row.
 */
export interface IPassageWaveformSummary {
  passageWaveformId: number;
  passageWaveformType: string; // 'E', 'M', 'G', 'A', 'T'
  isVerified: boolean;
  /** ML prediction: true = passage, false = not passage. Absent if no ML results. */
  mlPrediction?: boolean;
  /** ML confidence 0.0–1.0. Absent if no ML results. */
  mlConfidence?: number;
}

/**
 * Full waveform metadata (extends summary).
 * Matches DB table: PassageWaveform.
 * Used by single-passage detail views and the waveform data endpoint.
 */
export interface IPassageWaveform extends IPassageWaveformSummary {
  passageId: number;
  createdDate?: string;
  verificationDate?: string | null;
  frequencyRef?: number | null;
  numberOfSamples?: number | null;
  sampleRate?: number | null;
  machineLearningResults?: MachineLearningResult[];
}

/**
 * Waveform after base64 `data` has been decoded to a numeric sample array.
 * Produced by `decodeWaveforms()` in WaveformUtils.
 */
export interface IDecodedWaveform extends IPassageWaveform {
  data: number[];
}

/**
 * Shape returned by `GET /getWaveformData/{uid}/{passageWaveformId}`.
 */
export interface IWaveformApiResponse {
  sampleRate: number | null;
  timeEndOfSnippet: string | null;
  passageWaveforms: Array<IPassageWaveform & { data: string }>;
}

/**
 * Waveform type constants matching DB LookupPassageWaveformType
 */
export const WaveformType = {
  ELF: 'E',
  MAG: 'M',
  GEO: 'G',
  ACC: 'A',
  TMR: 'T',
} as const;

/**
 * Human-readable labels for waveform types
 */
export const WaveformTypeLabel: Record<string, string> = {
  E: 'ELF',
  M: 'MAG',
  G: 'GEO',
  A: 'INGEO',
  T: 'TMR',
  H: 'Manual',
};
